<template>
  <div>
    <client-activity
      :clientSlug="$route.params.clientSlug"
      class="mt-3"
      @triggerLogForm="triggerLogForm($event)"
      :key="logKey"
      @linkToChain="
        (serviceChainInformation = $event),
          triggerLogForm({ formType: 'Communication', ...$event })
      "
    ></client-activity>

    <v-navigation-drawer
      width="720"
      v-model="showLogForm"
      right
      temporary
      fixed
      clipped
    >
      <template v-slot:prepend>
        <v-card flat>
          <vue-card-title
            :title="`${logType} Log`"
            :subtitle="`Here you can create ${logType} log with client.`"
            :icon="$getIcon('mdiFileDocumentEdit')"
            closable
            dark
            @click="showLogForm = false"
            @close="showLogForm = false"
          >
          </vue-card-title>
          <v-divider></v-divider>
        </v-card>
      </template>

      <log-form
        :client="client"
        @refreshContactList="refreshContact += 1"
        v-if="showLogForm"
        :contactPerson="contactPerson"
        @contactPersonUpdate="contactPerson = $event"
        :contactPersonList="contactPersonList"
        :service-chain-information="serviceChainInformation"
        @close="(showLogForm = false), (serviceChainInformation = {})"
        @success="successForm"
      ></log-form>
    </v-navigation-drawer>
  </div>
</template>
<script>
import ClientActivity from "@/components/crm/client/components/clientActivityLogs";
import LogForm from "@/components/crm/client/components/logForm";
export default {
  components: {
    LogForm,
    ClientActivity
  },
  data() {
    return {
      client: null,
      logKey: 1,
      serviceChainInformation: {},
      logType: "Communication",
      refreshContact: 1,
      contactPerson: null,
      contactPersonList: [],
      showLogForm: false
    };
  },
  created() {
    this.getClientData();
  },
  methods: {
    triggerLogForm(event) {
      if (event.formType === "Communication" && !event.contactPerson) {
        return this.$store.dispatch("shell/showSnackbar", {
          text: `Please Select Contact Person.`,
          color: "red"
        });
      }
      this.logType = event.formType;
      this.showLogForm = true;
      this.contactPerson = event.contactPerson;
      if (event.contactPersonList) {
        this.contactPersonList = event.contactPersonList;
      }
    },
    successForm() {
      this.showLogForm = false;
      this.logKey = this.logKey + 1;
      this.serviceChainInformation = {};
    },
    getClientData() {
      const endpoint = `/api/v1/crm/clients/${this.$route.params.clientSlug}`;
      this.$axios.$get(endpoint).then(response => {
        this.client = response;
      });
    }
  }
};
</script>
